import type {
    WSCustomFieldEventCreated,
    WSCustomFieldEventDeleted,
    WSCustomFieldEventUpdated
} from '@he-novation/config/types/websockets/custom-field.ws.types';
import { asyncCustomFieldsFetch } from '@he-novation/front-shared/async/custom-fields.async';
import { useAtom } from 'jotai';
import uniqBy from 'lodash/uniqBy';
import { useSocketIO } from './useSocketIO';

import { customFieldsAtom } from '$atoms/custom-fields-atoms';

export function useCustomFields() {
    const [customFields, setCustomFields] = useAtom(customFieldsAtom);
    const { subscribe, unsubscribe } = useSocketIO();

    return {
        customFields,
        setCustomFields,
        fetchCustomFields(workspaceName: string) {
            return asyncCustomFieldsFetch(workspaceName).then(setCustomFields);
        },
        subscribeSocketIo(workspaceUuid: string) {
            subscribe!({
                socket: 'customFields',
                room: workspaceUuid,
                actions: {
                    sioCustomFieldCreated: ({ customField }: WSCustomFieldEventCreated) =>
                        setCustomFields((prev) =>
                            prev ? uniqBy([customField, ...prev], 'uuid') : prev
                        ),
                    sioCustomFieldUpdated: ({ customField }: WSCustomFieldEventUpdated) =>
                        setCustomFields((prev) =>
                            prev
                                ? prev.map((cf) =>
                                      cf.uuid === customField.uuid ? customField : cf
                                  )
                                : prev
                        ),
                    sioCustomFieldDeleted: ({ uuid }: WSCustomFieldEventDeleted) =>
                        setCustomFields((prev) =>
                            prev ? prev.filter((cf) => cf.uuid !== uuid) : prev
                        )
                }
            });
            return unsubscribe;
        }
    };
}
